<template>
  <form @submit.prevent="submit">
    <div class="mb-3">
      <label class="va-input__label">Дата</label>
      <input v-model="form.date" type="date" class="form-control" required />
      <span v-if="errors.date" class="error-message">{{ errors.date }}</span>
    </div>
    <va-checkbox
      v-model="form.is_working_day"
      label="Рабочий день"
      class="mb-3"
    />
    <div class="mb-3">
      <label class="va-input__label"
        >Ограничение типа доставки (пусто = все)</label
      >
      <select v-model="form.delivery_type_id" class="form-control">
        <option value="">Все типы</option>
        <option
          v-for="opt in deliveryTypeSelectOptions"
          :key="opt.value"
          :value="opt.value"
        >
          {{ opt.text }}
        </option>
      </select>
    </div>
    <va-input
      v-model.number="form.price_override"
      type="number"
      min="0"
      label="Надбавка к цене (пусто = без изменений)"
      class="mb-3"
      placeholder=""
    />
    <va-input
      v-model="form.comment"
      label="Комментарий"
      class="mb-4"
      placeholder=""
    />
    <div class="d-flex gap-2">
      <va-button type="submit" color="primary">Сохранить</va-button>
      <va-button type="button" @click="$emit('cancel')">Отмена</va-button>
    </div>
  </form>
</template>

<script>
export default {
  name: "DeliveryCalendarForm",
  props: {
    initial: { type: Object, default: null },
    deliveryTypes: { type: Array, default: () => [] },
  },
  data() {
    return {
      form: {
        date: "",
        is_working_day: true,
        delivery_type_id: "",
        price_override: null,
        comment: "",
      },
      errors: {},
    };
  },
  computed: {
    deliveryTypeSelectOptions() {
      return (this.deliveryTypes || [])
        .filter((o) => o.value != null && o.value !== "")
        .map((o) => ({
          value: Number(o.value),
          text: o.text || String(o.value),
        }));
    },
  },
  watch: {
    initial: {
      immediate: true,
      handler(val) {
        if (val && val.date) {
          this.form = {
            date: String(val.date).substring(0, 10),
            is_working_day: !!val.is_working_day,
            delivery_type_id:
              val.delivery_type_id != null && val.delivery_type_id !== ""
                ? Number(val.delivery_type_id)
                : "",
            price_override:
              val.price_override != null ? Number(val.price_override) : null,
            comment: val.comment || "",
          };
        } else {
          this.form = {
            date: "",
            is_working_day: true,
            delivery_type_id: "",
            price_override: null,
            comment: "",
          };
        }
        this.errors = {};
      },
    },
  },
  methods: {
    validate() {
      this.errors = {};
      if (!this.form.date) this.errors.date = "Обязательное поле";
      return Object.keys(this.errors).length === 0;
    },
    submit() {
      if (!this.validate()) return;
      this.$emit("submit", {
        date: this.form.date,
        is_working_day: this.form.is_working_day,
        delivery_type_id:
          this.form.delivery_type_id === "" ||
          this.form.delivery_type_id == null
            ? null
            : Number(this.form.delivery_type_id),
        price_override:
          this.form.price_override === "" || this.form.price_override == null
            ? null
            : Number(this.form.price_override),
        comment: this.form.comment.trim() || null,
      });
    },
  },
};
</script>

<style scoped>
.form-control {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.error-message {
  color: #e34a4a;
  font-size: 0.875rem;
}
</style>
